import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/endpoints';
import PageHeader from '../../components/PageHeader';
import { VehicleCard } from '../../components/Cards';
import {
  Badge, Button, Empty, Loading,
} from '../../components/Ui';
import { Reveal, stagger } from '../../components/Motion';
import { useToast } from '../../context/ToastContext';
import { colors } from '../../theme';

const MyVehiclesPage = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    api.vehicles.mine()
      .then((res) => setItems(res.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const toggleSold = async (v) => {
    await api.vehicles.markSold(v._id);
    load();
  };

  const remove = async (v) => {
    const ok = await toast.confirm({
      title: 'Delete listing',
      message: `Remove "${v.title}"?`,
      confirmLabel: 'Delete',
      danger: true,
    });
    if (!ok) return;
    await api.vehicles.remove(v._id);
    load();
  };

  return (
    <div>
      <PageHeader
        title="My vehicle listings"
        subtitle={`${items.length} listed`}
        right={<Button title="+ List another" size="sm" onClick={() => navigate('/vehicles/post')} />}
      />

      {loading ? <Loading /> : !items.length ? (
        <Empty
          emoji="🚗"
          title="No listings yet"
          text="List your car or bike and reach buyers near you."
          actionLabel="Sell a vehicle"
          onAction={() => navigate('/vehicles/post')}
        />
      ) : (
        <div className="grid grid-cards">
          {items.map((item, i) => (
            <Reveal key={item._id} delay={stagger(i, 55)}>
              <VehicleCard vehicle={item} onClick={() => navigate(`/vehicles/${item._id}`)} />
              <div
                className="row wrap"
                style={{
                  gap: 12, marginTop: -1, padding: 12,
                  background: '#fff', border: `1px solid ${colors.line}`,
                  borderTop: 0, borderRadius: '0 0 16px 16px',
                }}
              >
                <Badge value={item.isSold ? 'sold' : item.status} />
                <span className="t-tiny">
                  {item.viewCount || 0} views · {item.enquiryCount || 0} enquiries
                </span>
                <span className="grow" />
                <button type="button" className="link-btn" onClick={() => toggleSold(item)}>
                  {item.isSold ? 'Relist' : 'Mark sold'}
                </button>
                <button
                  type="button"
                  className="link-btn"
                  style={{ color: colors.danger }}
                  onClick={() => remove(item)}
                >
                  Delete
                </button>
                {item.rejectionReason ? (
                  <div className="t-tiny" style={{ color: colors.danger, width: '100%' }}>
                    Rejected: {item.rejectionReason}
                  </div>
                ) : null}
              </div>
            </Reveal>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyVehiclesPage;
